<template>
  <a-card :bordered="false" class="recharge-history">
    <!-- Query area -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="16" class="search-row">
          <a-col :md="6" :sm="24">
            <a-form-item :label="$t('investorList.czsj')">
              <a-range-picker
                v-model="queryParam.dateRange"
                format="DD-MM-YYYY"
                valueFormat="YYYY-MM-DD"
                style="width: 100%"
                :placeholder="[$t('Startdate'), $t('Enddate')]"
                @change="onDateChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item :label="$t('investorList.czlsh')">
              <a-input v-model="queryParam.mobile" :placeholder="$t('enter')" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item :label="$t('investorList.czzt')">
              <a-select
                v-model="queryParam.status"
                style="width: 100%"
                :placeholder="$t('investorList.qb')"
                allow-clear
              >
                <a-select-option :value="1">{{ $t('investorList.cg') }}</a-select-option>
                <a-select-option :value="10">{{ $t('investorList.sb') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item :label="$t('investorList.tzrlx')">
              <a-select v-model="queryParam.type" style="width: 100%" :placeholder="$t('investorList.qb')" allow-clear>
                <a-select-option :value="1">{{ $t('investorList.gr') }}</a-select-option>
                <a-select-option :value="10">{{ $t('investorList.qy') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <a-button type="primary" @click="handleSearch">{{ $t('search') }}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="toolbar">
      <!-- <a-button type="primary" icon="download" @click="handleExport">{{ $t('exportFile') }}</a-button> -->
    </div>

    <!-- Table area -->
    <a-table
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <span slot="type" slot-scope="text">
        {{ typeFilter(text) }}
      </span>
      <span slot="mobile" slot-scope="text">
        {{ text | maskPhone }}
      </span>
      <span slot="amount" slot-scope="text">
        {{ text | FenToDong }}
      </span>
      <span slot="status" slot-scope="text">
        {{ statusFilter(text) }}
      </span>
    </a-table>
  </a-card>
</template>

<script>
import { getRechargeList } from '@/webpublicapi/vietnamBackstage'
import moment from 'moment'
import lang from '@/i18n/lang'

export default {
  name: 'RechargeHistory',
  data() {
    return {
      lang,
      queryParam: {
        dateRange: [],
        startDate: '',
        endDate: '',
        id: '',
        status: undefined,
        type: undefined,
        mobile: '',
      },
      dataSource: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `${this.$t('components.total')} ${total} ${this.$t('components.items')}`,
      },
    }
  },
  computed: {
    columns() {
      return [
        { title: this.$t('investorList.czlsh'), dataIndex: 'followNo', align: 'center' },
        { title: this.$t('investorList.tzrmc'), dataIndex: 'name', align: 'center' },
        {
          title: this.$t('investorList.tzrzh'),
          dataIndex: 'mobile',
          align: 'center',
          scopedSlots: { customRender: 'mobile' },
        },
        {
          title: this.$t('investorList.tzrlx'),
          dataIndex: 'type',
          align: 'center',
          scopedSlots: { customRender: 'type' },
        },
        {
          title: this.$t('investorList.czje'),
          dataIndex: 'amount',
          align: 'center',
          scopedSlots: { customRender: 'amount' },
        },
        {
          title: this.$t('investorList.czzt'),
          dataIndex: 'status',
          align: 'center',
          scopedSlots: { customRender: 'status' },
        },
        { title: this.$t('investorList.czsj'), dataIndex: 'createdTime', align: 'center' },
      ]
    },
  },
  created() {
    const todayStart = moment().startOf('day')
    const todayEnd = moment().endOf('day')
    this.queryParam.dateRange = [todayStart, todayEnd]
    this.queryParam.startDate = todayStart.format('YYYY-MM-DD')
    this.queryParam.endDate = todayEnd.format('YYYY-MM-DD')
    this.loadData()
  },
  methods: {
    // Phone number masking
    maskPhone(phone) {
      if (!phone) return ''
      const phoneStr = String(phone)
      if (phoneStr.length <= 7) return phoneStr
      return phoneStr.substring(0, 3) + '****' + phoneStr.substring(phoneStr.length - 4)
    },
    statusFilter(status) {
      const statusMap = {
        1: this.$t('investorList.cg'),
        10: this.$t('investorList.sb'),
      }
      return statusMap[status] || this.$t('platformCollection.unknown')
    },
    typeFilter(type) {
      const typeMap = {
        1: this.$t('investorList.gr'),
        10: this.$t('investorList.qy'),
      }
      return typeMap[type] || this.$t('platformCollection.unknown')
    },
    onDateChange(dates, dateStrings) {
      if (!dates || dates.length === 0) {
        this.queryParam.startDate = ''
        this.queryParam.endDate = ''
        return
      }
      this.queryParam.startDate = this.queryParam.dateRange[0]
      this.queryParam.endDate = this.queryParam.dateRange[1]
    },
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    buildParams() {
      const rawParams = {
        mobile: this.queryParam.mobile,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        startDate: this.queryParam.startDate + ' 00:00:00',
        endDate: this.queryParam.endDate + ' 23:59:59',
        status: this.queryParam.status,
        type: this.queryParam.type,
      }

      return Object.keys(rawParams).reduce((acc, key) => {
        const value = rawParams[key]
        const shouldDrop = value === '' || value === undefined || value === null
        if (!shouldDrop) {
          acc[key] = value
        }
        return acc
      }, {})
    },
    loadData() {
      this.loading = true
      getRechargeList(this.buildParams())
        .then((res) => {
          if (res.success || res.respCode === 1000 || res.code === 200) {
            const data = res.respData || res.result || {}
            this.dataSource = data.records || []
            this.dataSource.forEach((item) => {
              item.createdTime = this.transformTime(item.createdTime, 2)
            })
            this.pagination.total = data.total || 0
          } else {
            this.$message.warning(res.respMsg || res.message || this.$t('platformCollection.query_failed'))
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleExport() {
      if (!this.dataSource.length) {
        this.$message.warning(this.$t('platformCollection.no_export_data'))
        return
      }

      const headers = [
        this.$t('platformCollection.recharge_serial_number'),
        this.$t('platformCollection.investor_name'),
        this.$t('platformCollection.investor_account'),
        this.$t('platformCollection.investor_type'),
        this.$t('platformCollection.recharge_amount'),
        this.$t('platformCollection.recharge_status'),
        this.$t('platformCollection.recharge_time'),
      ]
      const rows = this.dataSource.map((item) => [
        item.id,
        item.name,
        this.maskPhone(item.mobile),
        this.typeFilter(item.type),
        this.$options.filters.FenToDong ? this.$options.filters.FenToDong(item.amount) : item.amount,
        this.statusFilter(item.status),
        item.createdTime,
      ])

      const csvContent = [headers, ...rows]
        .map((line) => line.map((cell) => `"${String(cell === undefined ? '' : cell).replace(/"/g, '""')}"`).join(','))
        .join('\n')

      const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `${this.$t('platformCollection.recharge_record')}_${moment().format('YYYYMMDDHHmmss')}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';

.recharge-history {
  .table-page-search-wrapper {
    margin-bottom: 12px;
  }

  .toolbar {
    margin-bottom: 16px;
  }
}
</style>
